export const POPOVER_CONTENT = `
  We had to change the question you'll be asking,
  since your peer has already seen the one originally assigned to you.
`;
export const POPOVER_CONTENT_QUESTION = `The good news is that you\'re already familiar with this question, so no sweat :)`;
export const POPOVER_CONTENT_NEW_QUESTION = `
  Since you too had never seen this question before, read it together with your peer,
  and as they start solving it, review the hints and solution.
`;
export const POPOVER_BUTTON_LABEL = `Got it, I'll do my best :)`;
